export const dashboard = [
  {
    days: 31,
    hours: 22,
    minutes: 30,
    seconds: 0,
    registerCount: 170,
    schedulingCount: 145,
    target: '2020-01-27',
    start: '',
    end: '',
    createUserCount: 22,
  },
  {
    days: 11,
    hours: 22,
    minutes: 20,
    seconds: 0,
    registerCount: 40,
    schedulingCount: 29,
    target: '2020-02-27',
    start: '',
    end: '',
    createUserCount: 4,
  },
  {
    days: 0,
    hours: 4,
    minutes: 45,
    seconds: 0,
    registerCount: 10,
    schedulingCount: 8,
    target: '2020-03-27',
    start: '',
    end: '',
    createUserCount: 1,
  },
  {
    days: 55,
    hours: 2,
    minutes: 50,
    seconds: 0,
    registerCount: 338,
    schedulingCount: 303,
    target: '2020-04-27',
    start: '',
    end: '',
    createUserCount: 123,
  },
  {
    days: 0,
    hours: 12,
    minutes: 20,
    seconds: 0,
    registerCount: 10,
    schedulingCount: 8,
    target: '2020-05-27',
    start: '',
    end: '',
    createUserCount: 5,
  },
  {
    days: 44,
    hours: 3,
    minutes: 22,
    seconds: 0,
    registerCount: 39,
    schedulingCount: 33,
    target: '2020-06-27',
    start: '',
    end: '',
    createUserCount: 13,
  },
  {
    days: 43,
    hours: 3,
    minutes: 22,
    seconds: 0,
    registerCount: 39,
    schedulingCount: 33,
    target: '2020-07-27',
    start: '',
    end: '',
    createUserCount: 12,
  },
  {
    days: 40,
    hours: 5,
    minutes: 22,
    seconds: 0,
    registerCount: 44,
    schedulingCount: 39,
    target: '2020-08-27',
    start: '',
    end: '',
    createUserCount: 32,
  },
  {
    days: 40,
    hours: 5,
    minutes: 20,
    seconds: 0,
    registerCount: 44,
    schedulingCount: 39,
    target: '2020-09-27',
    start: '',
    end: '',
    createUserCount: 32,
  },
  {
    days: 40,
    hours: 5,
    minutes: 20,
    seconds: 0,
    registerCount: 44,
    schedulingCount: 39,
    target: '2020-10-27',
    start: '',
    end: '',
    createUserCount: 32,
  }
]

export const user = {
  availableLocations: ['AA', 'BB', 'CC', 'DD'],
  selectedLocation: 'AA',
  userLang: 'ja',
  userDayPlanNg: '【Remote】',
  userDayPlanOk: '*',
  userTimePlanNg: '【IN】',
  userTimePlanOk: '*',
  userSharingAdjustmentNg: '*',
  userSharingAdjustmentOk: 'example.com',
}

export const managementUsers = [
  {
    id: 1,
    role: 'Owner',
    license: 'Standard',
    status: 'Active',
    email: 'hajime@abejainc.com',
    nameEn: 'Hajime Saito',
    nameJa: '齋藤 創',
  },
  {
    id: 2,
    role: 'Admin',
    license: 'Standard',
    status: 'Active',
    email: 'test@abejainc.com',
    nameEn: 'Tesu Toichiro',
    nameJa: '手巣 統一郎',
  },
  {
    id: 3,
    role: 'Member',
    license: 'Standard',
    status: 'Active',
    email: 'sample@abejainc.com',
    nameEn: 'Samp ryuichi',
    nameJa: '山武 竜一',
  },
  {
    id: 4,
    role: 'Member',
    license: 'Trial',
    status: 'Inactive',
    email: 'disabled@abejainc.com',
    nameEn: 'Muko Yuza',
    nameJa: '向日 遊三',
  },
  {
    id: 5,
    role: 'Member',
    license: 'Free',
    status: 'Inactive',
    email: 'free@abejainc.com',
    nameEn: 'HIKAKIN',
    nameJa: 'ヒカキン',
  },
]
